export const isNewsTipsForm = (link: string) => {
    return link.startsWith('embeds://news-tips-form')
}
